module.exports = __webpack_public_path__ + "static/media/Inventory.d41d8cd9.js~";